export const STAFF_EMPLOYMENT_PAGE_QUERY_NAME = "StaffEmploymentPage"
